import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Box, Paper } from "@mui/material";
import axios from "axios";

import Button from "../../../Components/common/Button";
import EnhancedTable from "../../PoRequest/Table";
import Layout from "../../../Layout";
import instance from "../../../axios";
import { checkPrivileges, errorHandler } from "../../../Helpers";
import Loader from "../../../Layout/Loader";
import ConfirmDialoag from "../../../Components/common/ConfirmDialoag";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import TextField from "../../../Components/common/TextField";


const buildQuery = (filters) => {
  let qs = "";

  if (filters.deliveryNoteNumber) qs += `&deliveryNoteNumber=${filters.deliveryNoteNumber}`;
  if (filters.deliveryNoteRefNumber) qs += `&deliveryNoteRefNumber=${filters.deliveryNoteRefNumber}`;
  if (filters.plateNumber) qs += `&plateNumber=${filters.plateNumber}`;
  if (filters.stationCity) qs += `&stationCity=${filters.stationCity}`;
  if (filters.from) qs += `&from=${filters.from}`;
  if (filters.to) qs += `&to=${filters.to}`;

  qs += `&invoiceStatus=${filters.invoiceStatus ?? 1}`;

  if (filters.selectedVehicleId?.length) {
    qs += filters.selectedVehicleId.map(id => `&vehicleId=${id}`).join("");
  }

  if (filters.selectedAreaId?.length) {
    qs += filters.selectedAreaId.map(id => `&areaId=${id}`).join("");
  }

if (filters.account) qs += filters.account;
if(filters.vehicle) qs+=filters.vehicle;

  qs += filters.invoicemades || "&invoiceMade=0";

  if (filters.verticals) qs += filters.verticals;

  return qs;
};

const columns = [
    { id: "deliveryNoteNumber", numeric: false, disablePadding: false, label: "deliveryNoteNo" },
    { id: "deliveryNoteRefNumber", numeric: false, disablePadding: false, label: "deliveryNoteRefNumber" },
    { id: "contractNumber", numeric: false, disablePadding: false, label: "contractNumber" },
    { id: "serviceDate", numeric: false, disablePadding: false, label: "serviceDate" },
    { id: "plateNumber", numeric: false, disablePadding: false, label: "plateNumber" },
    { id: "taxableAmount", numeric: false, disablePadding: false, label: "amount" },
    { id: "saleVATAmount", numeric: false, disablePadding: false, label: "vatAmount" },
    { id: "saleNetAmount", numeric: false, disablePadding: false, label: "totalAmount" },
    { id: "creationMode", numeric: false, disablePadding: false, label: "creationMode" },
];
const buildUrl = (page, perPage, filters) => {
    const query = buildQuery(filters);
    return `/api/deliverynotes/getdnforpoinvoices?page=${page}&limit=${perPage}${query}`;
};
const PoInvoicesDn = forwardRef((props,ref) => {
    const navigate=useNavigate()
    const cancelSourceRef = useRef(null);
const fileInputRef = useRef(null);
    const [itemPagination, setItemPagination] = useState({ items: [] });
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [deliveryNoteNumber, setDeliveryNoteNumber] = useState("");
    const [deliveryNoteRefNumber, setDeliveryNoteRefNumber] = useState("");
    const [plateNumber, setPlateNumber] = useState("");
    const [stationCity, setStationCity] = useState("");
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [selectedAreaId, setSelectedAreaId] = useState([]);
    const [selectedVehicleId, setSelectedVehicleId] = useState([]);
    const [invoiceStatus, setInvoiceStatus] = useState(1);
    const [invoicemades, setInvoicemades] = useState("&invoiceMade=0")
    const [verticals, setVerticals] = useState("");
    const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([])
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [file, setFile] = useState(null);
    const [selectedTotal, setSelectedTotal] = useState(0);
  const [poRefNumber,setPoRefNumber]=useState("")
  const [account,setAccount]=useState(null)
  const [vehicle,setVehicle]=useState(null)
    const [poInvoicesDnSearch,setPoInvoicesDnsSearch]=useState({
    deliveryNoteNumber:"",
    deliveryNoteRefNumber:""
  })
  const handleRemoveFile = () => {
  setFile(null);
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

useImperativeHandle(ref, () => ({
  getPoInvoicesDns: async (params) => {
    if(params.to&&params.from){
        setFrom(params.from)
        setTo(params.to)
    }
    if(params.vehicle){
        setVehicle(params.vehicle)
    }
    if(params.account){
    setAccount(params.account)
    // setCurrentPage(1)
    }
  }
}));


    const fetchData = useCallback(
        async (page = currentPage, perPage = pageSize, reset = false) => {
            if (cancelSourceRef.current) {
                cancelSourceRef.current.cancel("Cancelled previous request");
            }
            cancelSourceRef.current = axios.CancelToken.source();
            const today = new Date();
let fromDate = from;
let toDate = to;

if (!from || !to) {
  toDate = today.toISOString(); 
  const last30Days = new Date();
  last30Days.setDate(today.getDate() - 30);
  fromDate = last30Days.toISOString();
}

            const filters = {
                     deliveryNoteNumber:poInvoicesDnSearch.deliveryNoteNumber,
        deliveryNoteRefNumber:poInvoicesDnSearch.deliveryNoteRefNumber,
                plateNumber,
                stationCity,
                from:fromDate,
                to:toDate,
                invoiceStatus,
                selectedAreaId,
                selectedVehicleId,
                invoicemades,
                verticals,
                account,
                vehicle
            };

            const url = buildUrl(page, perPage, filters);
            setLoader(true);
            try {
                const res = await axios.get(url, {
                    cancelToken: cancelSourceRef.current.token,
                });
                const responseData = res.data?.data || {};
                const list = responseData.data || [];
                const updatedItems = list.map((item) => ({
                    ...item,
                    check: selectedInvoiceIds.includes(item.id) || false,
                }));
                setItemPagination((prevState) => ({
                    ...prevState,
                    page: responseData.page,
                    pageSize: responseData.pageSize,
                    total: responseData.total,
                    hasNext: responseData.hasNext,
                    items: reset ? updatedItems : [...prevState.items, ...updatedItems], // 🔑
                }));
            } catch (err) {
                if (!axios.isCancel(err)) console.error(err);
            } finally {
                setLoader(false);
            }
        },
        [
            deliveryNoteNumber,
            deliveryNoteRefNumber,
            plateNumber,
            stationCity,
            from,
            to,
            invoiceStatus,
            selectedAreaId,
            selectedVehicleId,
            invoicemades,
            verticals,
            currentPage,
            vehicle,
            account,
            pageSize,
            poInvoicesDnSearch
        ]
    );

    useEffect(() => {
        fetchData(currentPage, pageSize, true);
    }, [
        currentPage,
        pageSize,
        deliveryNoteNumber,
        deliveryNoteRefNumber,
        plateNumber,
        stationCity,
        from,
        to,
        invoiceStatus,
        selectedAreaId,
        selectedVehicleId,
        invoicemades,
        verticals,
        vehicle,
        account,
    ]);
            const handlePoInvoicesDnSearch = (name, value) => {
        setPoInvoicesDnsSearch((prev) => ({
            ...prev,
            [name]: value
        }))
    }
    const onPageChange = (page) => {
        setCurrentPage(page);
    };

    const onRowsPerPageChange = (size) => {
        setPageSize(size);
        setCurrentPage(1);
    };

    const submitSideBarSearch = (data) => {
        const defaultInvoiceMades =
            data.invoicemades && data.invoicemades.length > 0 ? data.invoicemades : [0];

        const queryString2 = defaultInvoiceMades.map((item) => `&invoiceMade=${item}`).join("");
        const queryString = data.garageVerticals.map((item) => `&dnTypes=${item}`).join("");

        setTo(data.to);
        setFrom(data.from);
        setInvoiceStatus(data.invoiceStatus ?? 1);
        setSelectedAreaId(data.areaId || []);
        setSelectedVehicleId(data.vehicleId || []);
        setInvoicemades(queryString2 || "&invoiceMade=0");
        setVerticals(queryString || "");
        setStationCity(data.area || "");
        setCurrentPage(1);
    };


    const handleSelectionChange = (selectedIds) => {
        setItemPagination((prev) => ({
            ...prev,
            items: prev.items.map((it) => ({
                ...it,
                check: selectedIds.includes(it.id),
            })),
        }));

        setSelectedInvoiceIds((prev) => {
            const currentPageIds = itemPagination.items.map((it) => it.id);
            const filteredPrev = prev.filter((id) => !currentPageIds.includes(id));
            const updatedIds = [...filteredPrev, ...selectedIds];
            const total = itemPagination.items
                .filter((it) => updatedIds.includes(it.id))
                .reduce((sum, it) => sum + (it.saleNetAmount || 0), 0);

            setSelectedTotal(total);
            return updatedIds;
        });
    };


    const handleBack = () => {
       navigate("/process-invoices/individual")
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            alert("File size must be less than 5MB");
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            const fileData = event.target.result;
            // const typeCheck =
            //   fileData.split(":")[1].split("/")[1].toLowerCase().startsWith("pdf") ||
            //   fileData.split(":")[1].split("/")[1].toLowerCase().startsWith("vnd");

            // if (!typeCheck) {
            //   alert("Only PDF or Excel files are allowed");
            //   return;
            // }

            const obj = {
                name: file.name,
                contentType: file.type,
                oldUrl: "",
                entity: "invoice",
                entityId: selectedInvoiceIds[0],
                data: fileData.split("base64,")[1],
            };

            setFile(obj);
        };

        reader.readAsDataURL(file);
    };

    const showModal = () => {
        setIsOpenModal(true)
    }

    const closeModal = () => {
        setIsOpenModal(false)
        handleRemoveFile()    }
    const handleSubmit = async () => {
        try {
            let fileUrl = "";
            if (file) {

                const uploadRes = await instance.post("/api/uploads", file, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    },
                });

                fileUrl = uploadRes.url;
            }
            const payload = {
                requestedBy: 0,
                approveBy: 0,
                approveTime: "",
                archiveBy: 0,
                url: fileUrl,
                created: "",
                invoiceMade: 0,
                attributes: { dnIds: selectedInvoiceIds.join(","), counts: selectedInvoiceIds?.length || 0, estPrice: selectedTotal || 0 },
            };
                 if (poRefNumber?.trim()?.length) {
        payload.poRefNumber = poRefNumber
      }

            const res = await instance.post("/api/poinvoices/invoiceeachdn", payload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            closeModal()
            toast.success("Invoices Generated Successfully")
            fetchData(1, pageSize, true);
            setCurrentPage(1);
            setFile(null)
      setPoRefNumber("")
      handleBack()


            return res.data;
        } catch (err) {
            closeModal()
const message = err?.message || "Something went wrong";
const hintMatch = message.match(/\(HINT:\s*(.+)\)/i);
const displayMessage = hintMatch ? hintMatch[1] : message;
toast.error(displayMessage);

        }finally{
      setPoRefNumber("")
        }
    };
     const handleSearch = () => {
     fetchData(currentPage, pageSize, true);
    }
      const handleChange=(name,e)=>{
    setPoRefNumber(e.target.value)
  }
  if(!checkPrivileges("porequestCreate"))return
    return (
        <div>
            <div className="">
                {
                    loader ? <Loader /> : <>

                        <EnhancedTable
                            rows={itemPagination.items}
                            rowDefinition={columns}
                            title="Invoices-DN"
                            searchable
                            createButton={false}
                            showCheckbox
                            isEditable={false}
                            canUpdate
                            canDelete
                            isBack
                            poInvoicesDn={poInvoicesDnSearch}
                            handleSearch={handleSearch}
                            handlePoInvoicesDn={handlePoInvoicesDnSearch}
                            isPOInvoicesDn
                            onBack={handleBack}
                            onSelectionChange={handleSelectionChange}
                            onPageChange={onPageChange}
                            page={currentPage}
                            totalData={itemPagination.total}
                            rowsPerPage={pageSize}
                            isLoading={loader}
                            onRowsPerPageChange={onRowsPerPageChange}
                            translate={props.translate}
                            t={props.translate}
                        />
                        <Paper
                            elevation={2}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                my: 2,
                                // mx: 2,
                                p: 2,
                                borderRadius: "10px",
                            }}
                        >
                            <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                                Total Selected Amount: {selectedTotal.toLocaleString()}
                            </div>
                            <Button
                                variant="contained"
                                onClick={showModal}
                                color="primary"
                                disabled={selectedInvoiceIds.length === 0}
                            >
                            {props.translate("generate")}
                            </Button>
                        </Paper>


                    </>
                }
                {
                    isOpenModal &&
                    <ConfirmDialoag
                        bodyPadding={10}
                        noFullScreen
                        onCancel={closeModal}
                        onOk={handleSubmit}
                        title={props.translate('Please upload the required file')}>
                        <Box width={"400px"}>
                            <label
                                style={{
                                    padding: 10,
                                    border: `1px dashed`,
                                    borderRadius: 6,
                                    marginBottom: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <div style={{ marginRight: "auto" }}>
                                    {file ? file.name : props.translate("uploadFile")}
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        hidden
                                    />
                                </div>
                                {file ? (
      <Button
        color="error"
        component="span"
        onClick={(e) => {
          e.preventDefault();
          handleRemoveFile();
        }}
        variant="danger"
      >
        Remove
      </Button>
    ) : (
      <Button component="span">Browse file</Button>
    )}
                            </label>
                                               <TextField
                                   id="poRefNumber"
                                   label={props.translate("soRefNumber")}
                                   placeholder=""
                                   value={poRefNumber || ""}
                                   onChange={(e) =>
                                     handleChange("poRefNumber", e)
                                   }
                                   variant="outlined"
                                   margin="dense"
                                   fullWidth
                                 />
                        </Box>
                    </ConfirmDialoag>
                }

            </div>
        </div>
    );
});

export default PoInvoicesDn;
